export const IconFavoriteStarFilled: {
  name: 'icon_favorite_star_filled-59550f157a85'
} = {
  name: 'icon_favorite_star_filled-59550f157a85'
}
